<template>
    <form>
        <md-field :class="[{ 'md-error': errors.email }]">
            <label>{{ $t("common.email") }}</label>
            <md-input v-model="form.email" required :disabled="emailDisable && form.email"
                      @focus="clearError('email')"
            ></md-input>
            <span v-if="errors.email" class="validation-error">{{ errors.email }}</span>
        </md-field>
        <md-field :class="[{ 'md-error': errors.firstName }]">
            <label>{{ $t("common.firstName") }}</label>
            <md-input v-model="form.firstName" required
                      @focus="clearError('firstName')"
            ></md-input>
            <span v-if="errors.firstName" class="validation-error">{{ errors.firstName }}</span>
        </md-field>
        <md-field :class="[{ 'md-error': errors.surName }]">
            <label>{{ $t("common.lastName") }}</label>
            <md-input v-model="form.surName" required
                      @focus="clearError('surName')"
            ></md-input>
            <span v-if="errors.surName" class="validation-error">{{ errors.surName }}</span>
        </md-field>
        <md-field>
            <label>{{ $t("common.positionInCompany") }}</label>
            <md-input v-model="form.position"></md-input>
        </md-field>
        <md-field>
            <label>{{ $t("common.phone") }}</label>
            <md-input v-model="form.phone"></md-input>
        </md-field>
    </form>
</template>
<script>
export default {
    props: {
        info: { type: [Object, String], default: "" },
        emailDisable: { type: Boolean, default: false },
    },
    components: {},
    data() {
        return {
            form: {
                id: null,
                firstName: "",
                surName: "",
                email: "",
                position: "",
                phone: "",
            },
            errors: {
                email: "",
                firstName: "",
                surName: ""
            }
        };
    },
    methods: {
        getInfo() {
            return this.form;
        },
        validate() {
            let isValid = true;

            this.errors.email = "";
            if (!this.form.email) {
                this.errors.email = this.$t("common.validation.error.inputRequired");
                isValid = false;
            }

            this.errors.firstName = "";
            if (!this.form.firstName) {
                this.errors.firstName = this.$t("common.validation.error.inputRequired");
                isValid = false;
            }

            this.errors.surName = "";
            if (!this.form.surName) {
                this.errors.surName = this.$t("common.validation.error.inputRequired");
                isValid = false;
            }

            return isValid;
        },
        clearError(key) {
            this.errors[key] = "";
        }
    },
    watch: {
        info() {
            this.form = this.$mergeOnlyExistingProps(this.form, this.info);
        }
    }
};
</script>